import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Access from '../views/Access.vue'
import registration from "../store/modules/registration";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        component: Home
    },
    {
        path: '/access',
        name: 'access',
        component: Access
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/Login.vue')
    },
    {
        path: '/help',
        name: 'help',
        component: () => import(/* webpackChunkName: "user" */ '../views/Help.vue')
    },
    {
        path: '/app',
        name: 'app',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/App.vue'),
        redirect: {name: 'user-dashboard'},
        children: [
            {
                path: 'dashboard',
                name: 'user-dashboard',
                component: () => import(/* webpackChunkName: "user" */ '../views/user/Dashboard.vue')
            }
        ]
    },
    {
        path: '/register',
        name: 'register',
        redirect: {name: 'home'},
        component: () => import(/* webpackChunkName: "org" */ '../views/register/Register.vue'),
        children: [
            {
                path: 'success/:id/:code',
                name: 'register-success',
                component: () => import(/* webpackChunkName: "register" */ '../views/register/Success.vue'),
                props: true

            },
            {
                path: 'po/:id/:code',
                name: 'register-po',
                component: () => import(/* webpackChunkName: "register" */ '../views/register/PO.vue'),
                props: true
            },
            {
                path: 'receipt/:id/:code',
                name: 'register_receipt',
                component: () => import(/* webpackChunkName: "register" */ '../views/register/Receipt.vue'),
                props: true
            },
            {
                path: ':code',
                name: 'register-conference',
                component: () => import(/* webpackChunkName: "register" */ '../views/register/Conference.vue')
            }
        ]
    },
    {
        path: '/conference',
        name: 'conference',
        redirect: {name: 'home'},
        component: () => import(/* webpackChunkName: "org" */ '../views/conference/Conference.vue'),
        children: [
            {
                path: ':id/:code',
                name: 'conf-info',
                component: () => import(/* webpackChunkName: "register" */ '../views/conference/Information.vue'),
                props: true
            },
            {
                path: ':id/:code/:sess/:enroll/survey',
                name: 'sess-survey',
                component: () => import(/* webpackChunkName: "register" */ '../views/conference/SessionSurvey.vue'),
                props: true
            }
        ]
    },
    {
        path: '/records/:code',
        name: 'records',
        props: true,
        component: () => import(/* webpackChunkName: "org" */ '../views/Records.vue')
    },
    {
        path: '/org',
        name: 'organization',
        component: () => import(/* webpackChunkName: "org" */ '../views/organization/Organization.vue'),
        redirect: {name: 'org-dashboard'},
        children: [
            {
                path: 'dashboard',
                name: 'org-dashboard',
                component: () => import(/* webpackChunkName: "org" */ '../views/organization/Dashboard.vue')
            },
            {
                path: 'account',
                name: 'user-edit',
                component: () => import(/* webpackChunkName: "org" */ '../views/organization/user/Edit.vue')
            },
            {
                path: 'conference/new',
                name: 'new-conference',
                component: () => import(/* webpackChunkName: "org" */ '../views/organization/NewConference.vue')
            },
            {
                path: 'conference/:id',
                name: 'conference-details',
                component: () => import(/* webpackChunkName: "org" */ '../views/organization/conference/Details.vue'),
                props: true,
                redirect: {name: 'conf-registrations'},
                children: [
                    {
                        path: 'registrations',
                        name: 'conf-registrations',
                        component: () => import(/* webpackChunkName: "org" */ '../views/organization/conference/Registrations.vue')
                    },
                    {
                        path: 'edit',
                        name: 'conf-edit',
                        component: () => import(/* webpackChunkName: "org" */ '../views/organization/conference/Edit.vue')
                    },
                    {
                        path: 'info',
                        name: 'conf-information',
                        props: true,
                        component: () => import(/* webpackChunkName: "org" */ '../views/organization/conference/Information.vue')
                    },
                    {
                        path: 'comm',
                        name: 'conf-comm',
                        props: true,
                        component: () => import(/* webpackChunkName: "org" */ '../views/organization/conference/Communicate.vue')
                    },
                    {
                        path: 'sessions',
                        name: 'conf-sessions',
                        component: () => import(/* webpackChunkName: "org" */ '../views/organization/conference/Sessions.vue'),
                        props: true
                    },
                    {
                        path: 'sessions/new',
                        name: 'conf-session-new',
                        component: () => import(/* webpackChunkName: "org" */ '../views/organization/conference/session/New.vue'),
                        props: true
                    }
                ]
            },
            {
                path: 'conference/reg/:id/:code',
                name: 'conf-registration',
                component: () => import(/* webpackChunkName: "org" */ '../views/organization/registration/Details.vue'),
                props: true,
                redirect: {name: 'reg-info'},
                children: [
                    {
                        path: 'info',
                        name: 'reg-info',
                        props: true,
                        component: () => import(/* webpackChunkName: "org" */ '../views/organization/registration/Information.vue')
                    },
                    {
                        path: 'edit',
                        name: 'reg-edit',
                        props: true,
                        component: () => import(/* webpackChunkName: "org" */ '../views/organization/registration/Edit.vue')
                    },
                    {
                        path: 'po',
                        name: 'reg-po',
                        props: true,
                        component: () => import(/* webpackChunkName: "org" */ '../views/organization/registration/PO.vue')
                    },
                    {
                        path: 'comm',
                        name: 'reg-comm',
                        props: true,
                        component: () => import(/* webpackChunkName: "org" */ '../views/organization/registration/Communicate.vue')
                    },
                    {
                        path: 'tools',
                        name: 'reg-tools',
                        props: true,
                        component: () => import(/* webpackChunkName: "org" */ '../views/organization/registration/Tools.vue')
                    }
                ]
            },
            {
                path: 'conference/:id/sess/:sessId',
                name: 'conf-session',
                component: () => import(/* webpackChunkName: "org" */ '../views/organization/conference/session/Details.vue'),
                props: true,
                redirect: {name: 'sess-info'},
                children: [
                    {
                        path: 'info',
                        name: 'sess-info',
                        props: true,
                        component: () => import(/* webpackChunkName: "org" */ '../views/organization/conference/session/Information.vue')
                    },
                    {
                        path: 'surveys',
                        name: 'sess-surveys',
                        props: true,
                        component: () => import(/* webpackChunkName: "org" */ '../views/organization/conference/session/Surveys.vue')
                    },
                    {
                        path: 'edit',
                        name: 'sess-edit',
                        props: true,
                        component: () => import(/* webpackChunkName: "org" */ '../views/organization/conference/session/Edit.vue')
                    },
                    {
                        path: 'tools',
                        name: 'sess-tools',
                        props: true,
                        component: () => import(/* webpackChunkName: "org" */ '../views/organization/conference/session/Tools.vue')
                    }
                ]
            }

        ]
    },
    {
        path: '/conference/:id/sess/:sessId/surveys/print',
        name: 'print-sess-surveys',
        props: true,
        component: () => import(/* webpackChunkName: "org" */ '../views/organization/conference/session/PrintSurveys.vue')
    },
    {
        path: '/admin',
        name: 'admin',
        component: () => import(/* webpackChunkName: "org" */ '../views/admin/Admin.vue'),
        redirect: {name: 'admin-dashboard'},
        children: [
            {
                path: 'dashboard',
                name: 'admin-dashboard',
                component: () => import(/* webpackChunkName: "org" */ '../views/admin/Dashboard.vue'),
            },
            {
                path: 'org/:id',
                name: 'admin-org-details',
                component: () => import(/* webpackChunkName: "org" */ '../views/admin/organization/Details.vue'),
                redirect: {name: 'admin-org-confs'},
                children: [
                    {
                        path: 'confs',
                        name: 'admin-org-confs',
                        component: () => import(/* webpackChunkName: "org" */ '../views/admin/organization/Conferences.vue')
                    },
                    {
                        path: 'users',
                        name: 'admin-org-users'
                    },
                    {
                        path: 'edit',
                        name: 'admin-org-edit'
                    },
                    {
                        path: ':confId',
                        name: 'admin-conf',
                        component: () => import(/* webpackChunkName: "org" */ '../views/admin/organization/Registrations.vue')
                    }
                ]
            }
        ]
    }

]

const router = new VueRouter({
    scrollBehavior: (to, from, savedPosition) => {
        if (savedPosition) {
            return savedPosition;
        } else if (to.hash) {
            return {
                selector: to.hash
            };
        } else {
            return { x: 0, y: 0 };
        }
    },
    base: process.env.BASE_URL,
    routes
})

export default router
